import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';

export enum ClearRefinementButtonVariantsEnum {
  PRIMARY = ButtonVariantsEnum.PRIMARY,
  LINK = ButtonVariantsEnum.LINK,
}

/*
 * Props.
 */

interface ClearRefinementButtonProps {
  onClearRefinementOption: Handler;
  variant?: ClearRefinementButtonVariantsEnum;
}

/*
 * Component.
 */

export const ClearRefinementButton: FC<ClearRefinementButtonProps> = (props) => {
  const {onClearRefinementOption, variant} = props;

  switch (variant) {
    case ClearRefinementButtonVariantsEnum.LINK:
      return (
        <Button
          variant={ButtonVariantsEnum.LINK}
          size={VisualSizesEnum.SMALL}
          onClick={onClearRefinementOption}
        >
          <Trans id="clear-refinement-button-link">Clear</Trans>
        </Button>
      );
    default:
      return (
        <Button variant={ButtonVariantsEnum.PRIMARY} onClick={onClearRefinementOption}>
          <Trans id="clear-refinement-button-primary">Clear filter</Trans>
        </Button>
      );
  }
};
